import {
  getFeedsComments,
  getFeedsSearchComments,
} from '@/pages/opinion/services';
import { aigcSummarize, aigcUpload } from '@/pages/opinion/services/aigc';

/**
 *
 * @param params comments 的请求参数
 * @param prompt prompt
 * @param prompt stop  外部可以取消的回调函数
 * @param prompt cancelCallback 中断操作
 */

let cancel: (() => void) | null = null;
export async function getAigcSummary({
  params,
  prompt,
  stop,
  cancelCallback,
}: {
  params: any;
  prompt: string;
  stop?: { current: any };
  cancelCallback?: () => boolean;
}) {
  // 多次调用，先取消了
  cancel?.();
  cancel = null;

  const result = {
    status: 'loading',
    data: '',
  };

  const pageSize = 500;

  let page = 1;
  let data = '';
  let size = 0;
  const properties = { type: 'text/plain' };
  let blob = new Blob([], properties);
  let newFile;
  let total = 0;
  const formData = new FormData();
  const maxSize = 0.5 * 1024 * 1024; // 最大 0.5 mb

  do {
    try {
      const func =
        params?.search_data?.trim()?.length > 0
          ? getFeedsSearchComments
          : getFeedsComments;

      const res = await func({
        ...params,
        page,
        page_size: pageSize,
        exclude_translation: true,
      });

      if (res) {
        const { list = [], news_detail_info = [] } = res;

        let curList = [];

        if (typeof res.list !== 'undefined') {
          curList = list;
        } else if (typeof res.news_detail_info !== 'undefined') {
          curList = news_detail_info;
        }

        total = res.total;

        for (let i = 0; i < curList.length; i++) {
          const preData = data;
          const { content } = curList[i];

          data += `${content}\n`;

          if ((i + 1) % 50 === 0 || i === curList.length - 1) {
            // 每50条或者最后一条，创建Blob并检查大小
            blob = new Blob([data], properties);
            size = blob.size;
            if (size > maxSize) {
              console.log('文件过大，回退数据，跳出循环', content);
              const lines = preData.split('\n');
              data = lines.slice(0, -50).join('\n');
              blob = new Blob([data], properties);
              break;
            } else {
              console.log('添加数据', content);
            }
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
    page += 1;
    if (cancelCallback?.()) {
      return { status: 'cancel', data: '' };
    }
  } while (page * pageSize - pageSize < total && size < maxSize);

  if (blob.size <= 0) {
    result.status = 'failed';
  }

  blob.text().then((text) => console.log(text));

  newFile = new File([blob], 'aigc-file', properties);
  formData.append('file', newFile);

  console.log(
    'origin size',
    newFile.size,
    ', as size',
    newFile.size / 1024 / 1024,
    'mb',
  );

  if (!(newFile.size > 0)) {
    return {
      status: 'failed',
    };
  }

  let aigcUploadRes;

  try {
    aigcUploadRes = await aigcUpload(formData);
  } catch (err) {
    console.log(err);
    result.status = 'failed';
  }

  if (cancelCallback?.()) {
    return { status: 'cancel', data: '' };
  }

  try {
    const { filename } = aigcUploadRes;

    if (!filename) {
      result.status = 'failed';
    }

    const formData = new FormData();
    formData.append('map_prompt', prompt);
    formData.append('filename', filename);
    formData.append('combine_prompt', '');

    const prod = true;

    if (prod) {
      const aigcSummarizeRes = await aigcSummarize(formData, (cancelToken) => {
        cancel = cancelToken;
        if (stop) {
          stop.current = cancelToken;
        }
      });

      const { text } = aigcSummarizeRes;

      if (text) {
        result.status = 'success';
        result.data = text;
      } else {
        result.status = 'failed';
      }
    } else {
      aigcSummarize(formData, (cancelToken) => {
        cancel = cancelToken;
        if (stop) {
          stop.current = cancelToken;
        }
      });
      result.status = 'success';
      result.data = `Summary${prompt}`;
    }
  } catch (err) {
    console.log(err);
    result.status = 'failed';
  }

  if (cancelCallback?.()) {
    return { status: 'cancel', data: '' };
  }

  return result;
}
